import { render, staticRenderFns } from "./smsModal.vue?vue&type=template&id=204dc240&"
import script from "./smsModal.vue?vue&type=script&lang=js&"
export * from "./smsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports